
import * as PE91cnNoZWxmLmRhdGE6c2Vzc2lvbj4 from './Ourshelf-data-session.mjs';
import * as PE91cnNoZWxmOnNoYXJlZD4 from './Ourshelf-shared.mjs';
import * as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg from './androidx-compose-runtime-runtime.mjs';
import * as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4 from './compose-multiplatform-core-compose-ui-ui.mjs';
import * as PGtvdGxpbj4 from './kotlin-kotlin-stdlib.mjs';
import * as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI_ from './kotlinx-browser.mjs';
import * as PGlvLmt0b3I6a3Rvci1jbGllbnQtY29yZT4 from './ktor-ktor-client-core.mjs';
import { __ALL_EXPORTS as PE91cnNoZWxmLmRhdGE6c2Vzc2lvbj4__ALL_EXPORTS } from './Ourshelf-data-session.mjs';
import { __ALL_EXPORTS as PE91cnNoZWxmOnNoYXJlZD4__ALL_EXPORTS } from './Ourshelf-shared.mjs';
import { __ALL_EXPORTS as PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS } from './androidx-compose-runtime-runtime.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4__ALL_EXPORTS } from './compose-multiplatform-core-compose-ui-ui.mjs';
import { __ALL_EXPORTS as PGtvdGxpbj4__ALL_EXPORTS } from './kotlin-kotlin-stdlib.mjs';
import { __ALL_EXPORTS as PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS } from './kotlinx-browser.mjs';
import { __ALL_EXPORTS as PGlvLmt0b3I6a3Rvci1jbGllbnQtY29yZT4__ALL_EXPORTS } from './ktor-ktor-client-core.mjs';
import { __TAG as wasmTag, getCachedJsObject } from './kotlin-kotlin-stdlib.mjs'

// Placed here to give access to it from externals (js_code)
let wasmExports;

if (typeof process !== 'undefined' && process.release.name === 'node') {
    function doNotUseRequire() {
        throw new Error("Do not use top-level require. Prefer to use JS import or define your own require instead. Read more: https://kotl.in/r9txlt")
    }

    var require = new Proxy((function() {}), {
        apply(target, thisArg, argumentsList) {
            if (globalThis.require != null) {
                return globalThis.require.apply(thisArg, argumentsList);
            } else {
                doNotUseRequire();
            }
        },
        get(target, prop, receiver) {
            if (globalThis.require != null) {
                return Reflect.get(globalThis.require, prop);
            } else {
                doNotUseRequire();
            }
        },
    });
}

export function setWasmExports(exports) {
    wasmExports = exports;
}

const js_code = {

}

const StringConstantsProxy = new Proxy({}, {
  get(_, prop) { return prop; }
});

export const importObject = {
    js_code,
    intrinsics: {

        tag: wasmTag
    },
    "'": StringConstantsProxy,
    '<kotlin>': PGtvdGxpbj4__ALL_EXPORTS,
    '<org.jetbrains.kotlinx:kotlinx-browser>': PG9yZy5qZXRicmFpbnMua290bGlueDprb3RsaW54LWJyb3dzZXI___ALL_EXPORTS,
    '<Ourshelf:shared>': PE91cnNoZWxmOnNoYXJlZD4__ALL_EXPORTS,
    '<Ourshelf.data:session>': PE91cnNoZWxmLmRhdGE6c2Vzc2lvbj4__ALL_EXPORTS,
    '<io.ktor:ktor-client-core>': PGlvLmt0b3I6a3Rvci1jbGllbnQtY29yZT4__ALL_EXPORTS,
    '<androidx.compose.runtime:runtime>': PGFuZHJvaWR4LmNvbXBvc2UucnVudGltZTpydW50aW1lPg__ALL_EXPORTS,
    '<org.jetbrains.compose.ui:ui>': PG9yZy5qZXRicmFpbnMuY29tcG9zZS51aTp1aT4__ALL_EXPORTS,
};
    